<section class="page-container">
  <h1>Error</h1>
  <div class="message">
    @switch (errorReason) {
      @case (errorReasons.CommunityNotFound) {
        <h3>Community not found</h3>
      }
      @case (errorReasons.ProductNotEnabledForCommunity) {
        <h3>This {{currentProduct}} is not enabled. Please contact your MediaLab
        Representative to gain access.</h3>
      }
      @case (errorReasons.RouteNotFound) {
        <h3>
          @if (attemptedRoute) {
            <span>Sorry, we have no route configured for the following: {{attemptedRoute}}</span>
          }
          @if (!attemptedRoute) {
            <span>The URL you tried does not match any of our routes. Please double check it and try again.</span>
          }
        </h3>
      }
      @default {
        <h3>Unexpected error occurred</h3>
      }
    }
  </div>
</section>